import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from '../styles';

export function Spend() {
	return (
		<Row>
			<Col span={24}>
				<S.Title>{I18n.get('Kinebot can help your EHS team to save more!')}</S.Title>
				<S.Title>{I18n.get('Consult us for more information.')}</S.Title>
			</Col>
		</Row>
	);
}
